<template>
  <footer class="footer">
    <div class="container">
      <strong>Fundación Apoyo</strong>
      <span>Todos los derechos reservados © 2026</span>
      <a href="https://fundacionapoyo.com/wp-content/uploads/2023/04/Politica-para-Tratamiento-de-datos-personales.pdf" target="_blank">Política de protección de datos</a>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'FooterComponent',
  props: { }
}
</script>
